import installationInstructions from './installationInstructions';

const cw051Content = {
  installationInstructions
}

export { cw051Content };
